const listeners = new Set<() => void>();

/** Calls `listener` after each successful sync round; returns the unsubscribe. */
export function onSynced(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function notifySynced(): void {
  for (const listener of [...listeners]) listener();
}
